// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as AddRouteImport } from './routes/add'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LabAiFoodsRouteImport } from './routes/lab.ai-foods'
import { Route as AuthSignupRouteImport } from './routes/auth.signup'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthForgotRouteImport } from './routes/auth.forgot'
import { Route as AuthConsentRouteImport } from './routes/auth.consent'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsSubscriptionRouteImport } from './routes/settings.subscription'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsPasswordRouteImport } from './routes/settings.password'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsGoalRouteImport } from './routes/settings.goal'
import { Route as SettingsFeedbackRouteImport } from './routes/settings.feedback'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'

const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const AddRoute = AddRouteImport.update({
            id: '/add',path: '/add',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LabAiFoodsRoute = LabAiFoodsRouteImport.update({
            id: '/lab/ai-foods',path: '/lab/ai-foods',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const AuthResetRoute = AuthResetRouteImport.update({
            id: '/auth/reset',path: '/auth/reset',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AuthForgotRoute = AuthForgotRouteImport.update({
            id: '/auth/forgot',path: '/auth/forgot',getParentRoute: () => rootRouteImport
          })
const AuthConsentRoute = AuthConsentRouteImport.update({
            id: '/auth/consent',path: '/auth/consent',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsSubscriptionRoute = SettingsSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => SettingsRoute
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRoute
          })
const SettingsPasswordRoute = SettingsPasswordRouteImport.update({
            id: '/password',path: '/password',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsGoalRoute = SettingsGoalRouteImport.update({
            id: '/goal',path: '/goal',getParentRoute: () => SettingsRoute
          })
const SettingsFeedbackRoute = SettingsFeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => SettingsRoute
          })
const SettingsAccountRoute = SettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => SettingsRoute
          })





const SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,SettingsFeedbackRoute: SettingsFeedbackRoute,SettingsGoalRoute: SettingsGoalRoute,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPasswordRoute: SettingsPasswordRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsSubscriptionRoute: SettingsSubscriptionRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AddRoute: AddRoute,HistoryRoute: HistoryRoute,SettingsRoute: SettingsRouteWithChildren,AuthCallbackRoute: AuthCallbackRoute,AuthConsentRoute: AuthConsentRoute,AuthForgotRoute: AuthForgotRoute,AuthLoginRoute: AuthLoginRoute,AuthResetRoute: AuthResetRoute,AuthSignupRoute: AuthSignupRoute,LabAiFoodsRoute: LabAiFoodsRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)